<template>
  <v-card class="pdf-viewer" min-height="600px" width="100%">
    <v-toolbar dense>
      Editor
      <v-spacer/>
      <v-toolbar-items>
        <v-btn small :color="drawing ? 'success': ''" @click="drawing =!drawing">
          <v-icon>mdi-draw</v-icon>
        </v-btn>
        <v-menu offset-y >
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" v-on="on">
              <v-icon>mdi-circle-double</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in drawing_sizes" :key="index" @click="drawing_size = item">
              <v-chip>{{ item }}</v-chip>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y >
          <template v-slot:activator="{ on, attrs }">
            <v-btn small dark :color="drawing_color" v-bind="attrs" v-on="on">
              <v-icon>mdi-palette</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in drawing_colors" :key="index" @click="drawing_color = item">
              <v-chip :color="item"></v-chip>
            </v-list-item>
          </v-list>
        </v-menu>

<!--        <v-btn small>-->
<!--          <v-icon>mdi-undo</v-icon>-->
<!--        </v-btn>-->
<!--        <v-btn small>-->
<!--          <v-icon>mdi-redo</v-icon>-->
<!--        </v-btn>-->
        <v-btn small @click="save">
          save
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-divider/>
    <v-progress-linear v-if="progress > 0" v-model="progress" color="primary" height="25">
      <template v-slot:default="{ value }">{{ Math.ceil(value) }}%</template>
    </v-progress-linear>

    <v-sheet class="overflow-y-auto" max-height="600px">
      <template v-for="(item, idx) in pages">
        <PDFPage :id="`pdf-page-${idx+1}`" :page="item" :key="idx"
                 :scale="scale"
                 :optimalScale="optimalScale"
                 :drawing_color="drawing_color"
                 :drawing_size="drawing_size"
                 :drawing="drawing"
                 @input="pageHandler"
        />
        <!--          v-bind="{scale, optimalScale, fit, currentPage, pageCount, isPreviewEnabled}"-->
        <!--                   @scale-change="updateScale"/>-->

      </template>
    </v-sheet>
  </v-card>
</template>

<script>
import { jsPDF } from 'jspdf'
const PDFJS = require('pdfjs-dist/build/pdf');
PDFJS.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS.version}/pdf.worker.js`;
import PDFPage from './PDFPage';
import range from "lodash/range";


function getPages(pdf, first, last) {
  let allPages = range(first, last+1).map(number => pdf.getPage(number));
  return Promise.all(allPages);
}

function floor(value, precision) {
  const multiplier = Math.pow(10, precision || 0);
  return Math.floor(value * multiplier) / multiplier;
}

export default {
  name: 'PDFViewer',
  components: {
    PDFPage,
    // PDFPreview,
  },
  props: {
    src: String,
    url: String,
    upload_url: String,
    edit: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      pdf: undefined,
      pages: [],
      raw_pages: [],
      scale: 1.2,
      optimalScale: 1.2,
      drawing: false,
      drawing_color: '#f71313',
      drawing_colors: [
        '#f71313',
        '#22861B',
        '#1353f7',
        '#7513f7',
        '#f79413',
        '#d4f713',
      ],
      drawing_size: 1,
      drawing_sizes: [1, 2, 3, 4, 5],


      file: null,
      chunk_size: 500 * 1024,
      chunks: [],
      uploaded: 0
    };
  },
  computed: {
    progress() {
      if(!this.file) return 0
      return Math.floor((this.uploaded * 100) / this.file.size);
    },
  },
  watch: {
    src () {
      this.pdf = undefined
      this.pages = []
      this.raw_pages = []
      this.fetchPDF()
    },
    pdf(pdf) {
      if (!pdf) return;
      this.fetchPages()
    },
    chunks: function (n) {
      if (n.length > 0) this.upload();
    }
  },
  mounted() {
    this.fetchPDF()
  },
  methods: {
    fetchPDF() {
      PDFJS.disableWorker = true;
      PDFJS.getDocument({data: atob(this.src)})
          .promise
          .then(pdf => {this.pdf = pdf})
    },
    fetchPages() {
      if (!this.pdf) return;
      getPages(this.pdf, 1, this.pdf.numPages)
          .then(pages => { this.pages = pages })
          .catch((response) => {
            this.$emit('document-errored', {text: 'Failed to retrieve pages', response});
          });
    },
    pageHandler({page, canvas}) {
      this.raw_pages[page.pageNumber - 1] = canvas
    },
    save() {
      let doc = new jsPDF();
      this.raw_pages.forEach((item, idx) => {
        doc.addPage()
        doc.setPage(idx + 1)
        doc.addImage(item.toDataURL({format: 'png'}), "PNG", 0, 0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
            `page-${idx + 1}`,
            "FAST"
        )
      })
      doc.deletePage(this.raw_pages.length +1)
      // doc.save('marking_layout.pdf');
      this.file = doc.output('blob');
      this.createChunks()
    },
    async upload() {
      let chunk =  this.chunks[0]
      let formData = new FormData;
      this.uploaded+=chunk.size
      formData.set('is_last', this.chunks.length === 1);
      formData.set('file', chunk, `${this.file.name}.part`);
      await this.axios({
        method: 'POST',
        data: formData,
        url: this.upload_url,
        headers: {'Content-Type': 'application/octet-stream'},
      })
          .then(({data}) => {
            if(data.data) {
              this.$emit('uploaded', data.data)
              this.file = null
              this.uploaded = 0
            }
            this.chunks.shift();
          })
          .catch(error => {
            this.$emit('failed', error)
            this.file = null
            this.uploaded = 0
          });
    },
    createChunks() {
      let chunkSize = 1024 * 1024;
      let chunks = Math.ceil(this.file.size / chunkSize);

      let chunk = 0;
      let blobs = []
      while (chunk <= chunks) {
        let offset = chunk * chunkSize;
        blobs.push(this.file.slice(offset, offset+chunkSize))
        chunk++;
      }
      this.chunks = blobs
    },

    onDocumentRendered() {
      this.$emit('document-errored', this.url);
    },
    onDocumentErrored(e) {
      this.$emit('document-errored', e);
    },
    updateScale({scale, isOptimal = false}) {
      const roundedScale = floor(scale, 2);
      if (isOptimal) this.optimalScale = roundedScale;
      this.scale = roundedScale;
    },

  },
}
</script>
